import 'easy-autocomplete'
import SignaturePad from 'signature_pad';
import { showPropSpinner, hidePropSpinner } from './prop_spinner';

let signaturePad;

function resizeCanvas(canvas) {
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext("2d").scale(ratio, ratio);
}

function getResizedSignature(signaturePad, targetWidth, targetHeight) {
    const canvas = signaturePad.canvas;

    // Create a temporary canvas for resizing
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = targetWidth;
    tempCanvas.height = targetHeight;
    const ctx = tempCanvas.getContext('2d');

    // Fill with white background
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, targetWidth, targetHeight);

    // Draw the signature scaled down with high quality
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(canvas, 0, 0, targetWidth, targetHeight);

    return tempCanvas.toDataURL('image/png');
}

document.addEventListener("turbo:load", function() {
    console.log("Turbo:load - initializing logbook features");

    // Initialize signature pad
    initializeSignaturePad();

    // Existing jQuery code
    $(document).ready(function() {
        var totalTimeVar = "Previous total: " + $('#totalTimeDiv').data('totalTime');
        if ($('#logbook_book_type_id').val() === "") {
            $('#logbook_total_time').attr('placeholder', '');
        } else {
            var defaultPlaceholder = $('#logbook_total_time').data('defaultPlaceholder');
            $('#logbook_total_time').attr('placeholder', defaultPlaceholder);
        }

        $('#logbook_book_type_id').change(function() {
            if ($(this).val() === "") {
                $('#logbook_total_time').attr('placeholder', '');
            } else {
                var defaultPlaceholder = $('#logbook_total_time').attr('data-default-placeholder');
                $('#logbook_total_time').attr('placeholder', totalTimeVar);
            }
        });

        $('#logbook_book_type_id').change(function() {
            var work_item_id = $(this).val();
            var aircraft_id = $('#aircraftDiv').data('aircraft-id');
            var dropdownValue = $('#logbook_book_type_id').val();
            let myVariable;
            $.ajax({
                url: "/aircrafts/" + aircraft_id + "/components/book_components",
                method: "GET",
                data: {book_type_id: dropdownValue},
                dataType: "json",
                success: function(data) {
                    $('#logbook_component_ids').find('option').remove();
                    $.each(data, function(i, item){
                        $('#logbook_component_ids').append($('<option>').text(item[1]).attr('value', item[0]));
                    });
                }
            })
        });

        $('#printLabelButton').on('click', function(e) {
            e.preventDefault();
            var content = $('#logPagePrint .modal-body').html();
            printModalContent(content);
        });
    });

    // Function to initialize autocomplete on an input
    function initializeAutocomplete($input) {
        console.log("Initializing autocomplete for:", $input.attr('id'));

        var options = {
            url: function(phrase) {
                console.log("Fetching results for phrase:", phrase);
                return "/works/search.json?q=" + phrase;
            },
            getValue: "name",
            list: {
                onChooseEvent: function() {
                    console.log("onChooseEvent triggered");
                },
                onSelectItemEvent: function() {
                    console.log("onSelectItemEvent triggered");

                    var selectedData = $input.getSelectedItemData();
                    console.log("selectedData:", selectedData);

                    if (!selectedData) {
                        console.log("No selected data");
                        return;
                    }

                    var name = selectedData.name;
                    var description = selectedData.description;
                    var ad_id = selectedData.ad;
                    console.log("name:", name, "description:", description, "ad_id:", ad_id);

                    var inputId = $input.attr('id');
                    console.log("inputId:", inputId);

                    var match = inputId.match(/logbook_works_attributes_(.+?)_name/);
                    console.log("match:", match);

                    if (match) {
                        var index = match[1];
                        console.log("index:", index);
                        console.log("Setting values for fields with index:", index);
                        $("#logbook_works_attributes_" + index + "_description").val(description).trigger("change");
                        $('#logbook_works_attributes_' + index + '_ad_id').val(ad_id).trigger("change");
                    }
                }
            }
        };

        $input.easyAutocomplete(options);
        // Easy Autocomplete reads input width at init time and can write 0px as an
        // inline style when the element hasn't been laid out yet. Force 100% after init.
        $input.closest('.easy-autocomplete').css('width', '100%');
    }

    // Initialize autocomplete on existing fields
    console.log("Looking for autocomplete inputs...");
    var $inputs = $('*[data-behavior="autocomplete"]');
    console.log("Found autocomplete inputs:", $inputs.length, $inputs);

    $inputs.each(function() {
        initializeAutocomplete($(this));
    });

    // Initialize autocomplete on dynamically added fields (via Cocoon)
    $(document).on('cocoon:after-insert', function(e, insertedItem) {
        console.log("Cocoon after-insert triggered");
        var $newInput = insertedItem.find('*[data-behavior="autocomplete"]');
        if ($newInput.length > 0) {
            console.log("Found new autocomplete input in inserted item");
            initializeAutocomplete($newInput);
        }
    })
});

// Signature Pad Initialization
function initializeSignaturePad() {
    const canvas = document.getElementById("signature-pad");

    if (!canvas) {
        console.log("Signature canvas not found on this page");
        return;
    }

    console.log("Canvas found, setting up signature pad");

    const modal = document.getElementById('signatureModal');

    if (!modal) {
        console.error("Signature modal not found!");
        return;
    }

    // Initialize on modal shown
    modal.addEventListener('shown.bs.modal', function () {
        console.log("Modal shown event - initializing SignaturePad instance");
        resizeCanvas(canvas);

        signaturePad = new SignaturePad(canvas, {
            backgroundColor: 'rgb(255, 255, 255)',
            penColor: 'rgb(0, 0, 0)',
            minWidth: 1,
            maxWidth: 3
        });

        console.log("SignaturePad instance created");

        // Load existing signature if present
        const hiddenField = document.getElementById('signature-data-field');
        if (hiddenField && hiddenField.value) {
            console.log("Loading existing signature");
            const img = new Image();
            img.onload = function() {
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
            };
            img.src = hiddenField.value;
        }
    });

    // Clear button
    const clearButton = document.getElementById("clear-signature");
    if (clearButton) {
        clearButton.addEventListener("click", (e) => {
            e.preventDefault();
            if (signaturePad) {
                signaturePad.clear();
                console.log("Signature cleared");
            }
        });
    }

    // Save button
    const saveButton = document.getElementById("save-signature");
    if (saveButton) {
        saveButton.addEventListener("click", (e) => {
            e.preventDefault();
            console.log("Save button clicked");

            if (!signaturePad) {
                alert("Signature pad not initialized. Please close and reopen the modal.");
                return;
            }

            if (signaturePad.isEmpty()) {
                alert("Please provide a signature.");
                return;
            }

            // Get resized signature (300x120 pixels)
            const dataUrl = getResizedSignature(signaturePad, 300, 120);
            console.log("Signature captured and resized, data URL length:", dataUrl.length);

            // Store in hidden field
            const hiddenField = document.getElementById('signature-data-field');
            if (hiddenField) {
                hiddenField.value = dataUrl;
                console.log("Signature saved to hidden field");
            } else {
                console.error("Hidden field 'signature-data-field' not found!");
            }

            // Update preview
            updateSignaturePreview(dataUrl);

            // Close modal
            const modalInstance = bootstrap.Modal.getInstance(modal);
            if (modalInstance) {
                modalInstance.hide();
            }

            // Show success message
            showSignatureSuccess();
        });
    }
}

function updateSignaturePreview(dataUrl) {
    let preview = document.getElementById('signature-preview');
    if (!preview) {
        const signatureSection = document.querySelector('.signature-section');
        if (signatureSection) {
            preview = document.createElement('div');
            preview.id = 'signature-preview';
            preview.className = 'mt-3';
            signatureSection.appendChild(preview);
        }
    }

    if (preview) {
        preview.innerHTML = `
            <div class="card" style="max-width: 300px;">
                <div class="card-body p-2">
                    <img src="${dataUrl}" class="img-fluid" style="border: 1px solid #dee2e6; background: white;" alt="Signature preview">
                    <small class="text-muted d-block mt-1">
                        <i class="fas fa-check-circle text-success"></i> Signature captured (300x120px)
                    </small>
                </div>
            </div>
        `;
    }
}

function showSignatureSuccess() {
    const button = document.querySelector('[data-bs-target="#signatureModal"]');
    if (button) {
        const originalHTML = button.innerHTML;
        button.innerHTML = '<i class="fas fa-check me-2"></i>Signature Saved';
        button.classList.remove('btn-outline-primary');
        button.classList.add('btn-success');

        setTimeout(() => {
            button.innerHTML = originalHTML;
            button.classList.remove('btn-success');
            button.classList.add('btn-outline-primary');
        }, 2000);
    }
}

// Inject Generate button into Trix toolbar
document.addEventListener('trix-initialize', function(event) {
    const toolbarElement = event.target.toolbarElement;
    const buttonRow = toolbarElement.querySelector('.trix-button-row');
    if (!buttonRow || toolbarElement.querySelector('[data-trix-action="x-generate"]')) return;

    const buttonGroup = document.createElement('span');
    buttonGroup.className = 'trix-button-group';
    buttonGroup.innerHTML = `
        <button type="button" class="trix-button" title="Generate description from form fields"
                data-trix-action="x-generate">
            <i class="fas fa-magic"></i> Generate
        </button>
    `;
    buttonGroup.querySelector('button').addEventListener('click', function(e) {
        e.preventDefault();
        window.generate_description();
    });
    buttonRow.appendChild(buttonGroup);
});

// Existing global functions
window.generate_description = async function() {
    const trixEditor = document.querySelector('trix-editor');
    if (!trixEditor) return false;

    const aircraftId = $('#aircraftDiv').data('aircraft-id');
    if (!aircraftId) return false;

    // Confirm if the editor already has content
    const existingText = trixEditor.editor.getDocument().toString().trim();
    if (existingText.length > 0) {
        const confirmed = confirm('This will replace the existing description, including any embedded signature. Continue?');
        if (!confirmed) return false;
    }

    // Collect work items from visible nested fields
    const workItems = [];
    document.querySelectorAll('.nested-fields').forEach(function(container) {
        const destroyField = container.querySelector('input[name$="[_destroy]"]');
        if (destroyField && destroyField.value === '1') return;
        const nameEl = container.querySelector('input[id$="_name"]');
        const descEl = container.querySelector('textarea[id$="_description"]');
        const name = nameEl ? nameEl.value.trim() : '';
        const description = descEl ? descEl.value.trim() : '';
        if (name || description) workItems.push({ name, description });
    });

    const payload = {
        n_number:            $('#aircraftDiv').data('n-number'),
        entry_date:          $('#logbook_entry_date').val(),
        tach:                $('#logbook_tach').val(),
        hobbs:               $('#logbook_hobbs').val(),
        total_time:          $('#logbook_total_time').val(),
        shop:                $('#logbook_shop').val(),
        mechanic:            $('#logbook_mechanic').val(),
        mechanic_faa_number: $('#logbook_mechanic_faa_number').val(),
        cost:                $('#logbook_cost').val(),
        work_hours:          $('#logbook_hours').val(),
        oil_change:          String($('#logbook_oil_change').is(':checked')),
        annual:              String($('#logbook_annual').is(':checked')),
        work_items:          workItems
    };

    // Loading state on toolbar button
    const generateBtn = document.querySelector('[data-trix-action="x-generate"]');
    if (generateBtn) {
        generateBtn.disabled = true;
        generateBtn.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i> Generating…';
    }

    // Spinning prop overlay on the description card body
    const cardBody = trixEditor.closest('.card-body');
    if (cardBody) showPropSpinner(cardBody, 'Generating description…');

    try {
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
        const response = await fetch(`/aircrafts/${aircraftId}/logbooks/generate_description`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken
            },
            body: JSON.stringify(payload)
        });

        const data = await response.json();

        if (!response.ok) {
            alert(data.error || 'Failed to generate description. Please try again.');
            return false;
        }

        // Replace editor content with generated text
        const editor = trixEditor.editor;
        editor.setSelectedRange([0, editor.getDocument().getLength() - 1]);
        editor.deleteInDirection('forward');

        let html = '';
        if (data.date)     html += `<div><strong>Date: ${data.date}</strong></div>`;
        if (data.aircraft) html += `<div><strong>Aircraft: ${data.aircraft}</strong></div>`;
        if (data.body)     html += `<div><br></div><div>${data.body}</div>`;
        if (data.signoff)  html += `<div><br></div><div><em>${data.signoff}</em></div>`;
        if (html)          editor.insertHTML(html);
    } catch (e) {
        alert('An error occurred while generating. Please try again.');
    } finally {
        if (generateBtn) {
            generateBtn.disabled = false;
            generateBtn.innerHTML = '<i class="fas fa-magic"></i> Generate';
        }
        hidePropSpinner();
    }

    return false;
};

window.add_work_item = async function(elmnt) {
    var $nestedFields = $(elmnt).closest('.nested-fields');

    var name        = $nestedFields.find('input[id$="_name"]').val();
    var description = $nestedFields.find('textarea[id$="_description"]').val();
    var ad_id       = $nestedFields.find('input[id$="_ad_id"]').val();
    var aircraft_id = $("#logbook_aircraft_id").val();
    var user_id     = $("#logbook_user_id").val();

    const work = { user_id, aircraft_id, ad: ad_id, description, name, js: true };

    try {
        const response = await fetch("/master_work_items", {
            method: 'POST',
            body: JSON.stringify(work),
            headers: { 'Content-Type': 'application/json' }
        });
        if (response.ok) {
            alert("Work item saved as Master.");
        } else {
            alert("Failed to save master work item. Please try again.");
        }
    } catch (e) {
        alert("An error occurred while saving. Please try again.");
    }
}

function printModalContent(content) {
    var printWindow = window.open('', '_blank');
    printWindow.document.write('<html><head><title>Print</title></head><body>');
    printWindow.document.write(content);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
}